var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_IMAGE_CHOICES, GLASS_BREAKAGE_TRAD_KEYS, GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_ANSWERS, } from '@declaration/constants/glassBreakageDamageConstants';
import { GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_OPTIONS } from '@shared/constants/glassBreakageDamageConstants';
import { GlassBreakageRoomDamagesCause, GlassBreakageRoomDamagesOrigin, } from '@shared/types/api/glassBreakageDamage';
const claim = namespace('claim');
const qualification = namespace('qualification');
let GlassBreakageDamageTypeQuestion = class GlassBreakageDamageTypeQuestion extends QuestionComponent {
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['room-damages-cause-panel-title']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['room-damages-cause-question-sidebar_title'];
        return key && this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get roomDamageCauseChoices() {
        return GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_IMAGE_CHOICES;
    }
    get roomDamageUnknownChoice() {
        return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_OPTIONS.inconnue);
    }
    get selectedValue() {
        return this.qualification.roomDamagesCause;
    }
    get answer() {
        if (this.selectedValue === null) {
            return null;
        }
        return this.$tc(GLASS_BREAKAGE_ROOM_DAMAGES_CAUSE_ANSWERS[this.selectedValue]);
    }
    onUpdate(roomDamagesCause = GlassBreakageRoomDamagesCause.Unknown) {
        const qualificationPayload = {
            roomDamagesCause,
        };
        if (roomDamagesCause === GlassBreakageRoomDamagesCause.Unknown &&
            !this.qualification.roomDamagesOrigin) {
            qualificationPayload.roomDamagesOrigin = GlassBreakageRoomDamagesOrigin.Unknown;
        }
        this.updateAndSaveGlassBreakageDamageQualification({
            step: this.step,
            qualificationPayload,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakageDamageTypeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], GlassBreakageDamageTypeQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakageDamageTypeQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakageDamageTypeQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakageDamageTypeQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
GlassBreakageDamageTypeQuestion = __decorate([
    Component({
        components: { RadioImageButton, QuestionPanel, UiButton },
        props: QuestionProps,
    })
], GlassBreakageDamageTypeQuestion);
export default GlassBreakageDamageTypeQuestion;
